<template>
    <div class="card">
      <div class="card-body">
        <LocalDataTable :columns="columns" :init-document="is_mounted" ajax-link="productBrand/ListAjax" :functions="functions"></LocalDataTable>
      </div>
    </div>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import LocalDataTable from "@/components/LocalDataTable";
import Swal from 'sweetalert2';
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "ListProductBrand",
  components: {LocalDataTable, MasterLayout},
  data(){
    return{
      is_mounted : mounted,
      columns : [
        { title : 'عنوان' },
        { title: 'عنوان انگلیسی' },
        { title: 'امکانات' ,searchable : false,sortable : false},
      ],
      functions:[
        {name: 'delBrand',method : this.delBrand}
      ],
    }
  },
  async mounted()
  {
    this.setPageTitle('لیست برندهای محصولات');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async delBrand(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به برند محصول حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteProductBrand(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>